import { Link } from "react-router-dom";

const borrowerLinks = [
  ["/uk/lending-products", "Lending products"],
  ["/complaints", "Complaints"],
  ["/financial-difficulty", "Financial difficulty"],
  ["/tariff", "Tariff of charges"],
  ["/vulnerable-customers", "Vulnerable customers"],
  ["/fair-treatment", "Fair treatment"],
  ["/intermediaries/terms", "Intermediary terms"],
];

const legalLinks = [
  ["/regulatory-information", "Regulatory information"],
  ["/investor-access", "Investor access"],
  ["/privacy", "Privacy policy"],
  ["/legal#terms", "Terms of use"],
  ["/legal#cookies", "Cookie notice"],
  ["/financial-crime", "Financial crime"],
  ["/whistleblowing", "Whistleblowing"],
  ["/modern-slavery", "Modern slavery"],
  ["/accessibility", "Accessibility"],
  ["/policies", "All policies"],
];

export default function Footer() {
  return (
    <footer>
      <div className="wrap">
        <div className="top">
          <div>
            <div className="brand" style={{ marginBottom: 14 }}>
              <img src="/df-logo.png" alt="" />
              <span>Daksfirst</span>
            </div>
            <p className="line">A specialist credit group operating across the UK, India and Frontier Markets.</p>
            <p className="line" style={{ marginTop: 14 }}>
              <a href="mailto:info@daksfirst.com">info@daksfirst.com</a><br />
              <Link to="/data-room">Investor data room &rarr;</Link>
            </p>
          </div>
          <div>
            <h4>London</h4>
            <p className="line">8 Hill Street<br />Mayfair, London W1J 5NG<br />+44 20 7698 2709</p>
          </div>
          <div>
            <h4>Mumbai</h4>
            <p className="line">603, A Wing, Prathamesh Tower<br />Raghuwanshi Mills Compound<br />Senapati Bapat Marg<br />Lower Parel, Mumbai 400013<br />+91 22 6212 0441</p>
          </div>
          <div>
            <h4>UK borrowers</h4>
            <ul className="footer-links">
              {borrowerLinks.map(([to, label]) => <li key={to}><Link to={to}>{label}</Link></li>)}
              <li><Link to="/faqs">FAQs</Link></li>
            </ul>
          </div>
          <div>
            <h4>Legal and regulatory</h4>
            <ul className="footer-links">
              {legalLinks.map(([to, label]) => <li key={to}><Link to={to}>{label}</Link></li>)}
            </ul>
          </div>
        </div>

        <p className="line india-line">
          <strong>India group companies:</strong>{" "}
          <a href="https://kifpl.com" target="_blank" rel="noopener noreferrer">Komac Investments and Finance</a>,{" "}
          <a href="https://ifhl.in" target="_blank" rel="noopener noreferrer">India Finance House</a> and{" "}
          <a href="https://amolfinance.com" target="_blank" rel="noopener noreferrer">Amol Financial Services</a>{" "}
          publish their own regulatory policies on their own websites.
        </p>

        <p className="line nodal-officer">
          <strong>Accessibility:</strong> our <Link to="/accessibility">accessibility statement</Link> includes the nodal officer appointed under SEBI Circular SEBI/HO/ITD-1/ITD_VIAP/P/CIR/2025/131.
        </p>

        <p className="disclaimer">
          Daksfirst Limited (registered in England and Wales, company number 11626401, VAT 373672277, registered office 8 Hill Street, London, England, W1J 5NG) is an Appointed Representative of Maystone Capital Limited, which is authorised and regulated by the Financial Conduct Authority (FRN 758412). Daksfirst's AR registration number is 937220. This website is provided for information only and does not constitute an offer or solicitation to invest. Investments in the funds described are open to professional and institutional investors only.
        </p>
        <div className="copy">
          <span>&copy; 2026 Daksfirst Limited. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
